/** One registered vehicle of an inventory item; the same name may appear with different max pax. */
export type VehicleOptionLike = { vehicleType: string; pax?: number | string | null };

const SEPARATOR = "||";

/** Unique form/Select value for a vehicle: its name and max pax, so "Big Bus" 29 and 39 are distinct. */
export const vehicleOptionValue = (option?: VehicleOptionLike | null): string | null =>
  option?.vehicleType ? `${option.vehicleType}${SEPARATOR}${Number(option.pax) || 0}` : null;

/** Value of the first registered vehicle, or null when there are none. */
export const firstVehicleValue = (options?: VehicleOptionLike[] | null): string | null => vehicleOptionValue(options?.[0]);

/** Splits a vehicle value into its name and max pax; a plain name (no pax) is accepted. */
export const parseVehicleValue = (value?: string | null): { vehicleType: string | null; pax: number | null } => {
  if (!value) return { vehicleType: null, pax: null };
  const at = value.lastIndexOf(SEPARATOR);
  if (at < 0) return { vehicleType: value, pax: null };
  return { vehicleType: value.slice(0, at), pax: Number(value.slice(at + SEPARATOR.length)) || null };
};
